import routerOptions0 from "/tmp/build/ad8838f6/customer-website-pr/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.14.1_db0@0.3.1_eslint@8.57.1_idb-keyval@6.2._yhgabb7n53rapqrwhb27gmpsg4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}